// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vselect-custom{border:1px solid #ced4da;border-radius:.375rem;min-height:38px;padding:0;font-size:.875rem}.vselect-custom .vs__dropdown-toggle{border:none;padding:.375rem .75rem;background-color:#fff}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
